import React, { useEffect, useState } from "react";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import caseStudies from "./caseStudiesContent";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../../styles/commonStyle.scss";
import "../../styles/caseStudies/style.scss";

const CaseStudiesComponent = ({ titleName, selectedId, ref }) => {
  const navigate = useNavigate();
  const [selectedFooter, setSelectedFooter] = useState(1);

  const moreCaseStudyClickFunc = (name) => {
    navigate(`/casestudies/${name}`);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    beforeChange: (prev, next) => {
      setSelectedFooter([0, 1, 2].includes(next) ? 1 : 2);
    },
  };

  return (
    <div
      ref={ref}
      className={
        titleName
          ? "related-case-studies-wrapper case-studies-wrapper "
          : "case-studies-wrapper"
      }
    >
      {!titleName && <div className="case-studies-heading">Case Studies</div>}
      {!titleName && (
        <div className="case-studies-sub-heading">
          Real results for real clients. See how our strategies drive success.
        </div>
      )}
      {titleName && (
        <div className="related-cast-studies">Related Case Studies</div>
      )}

      {/* desktopResponsive */}
      <div className="case-studies-card-wrapper case-studies-desktop-view">
        {caseStudies.caseStudies.map((data) => {
          return titleName ? (
            data.name != selectedId && (
              <Card key={data.id} className="case-studies-card">
                <CardMedia component="img" image={data.image} alt="financial" />
                <CardContent className="case-studies-card-content-wrapper">
                  <div className="case-studies-content-wrapper">
                    <div className="case-studies-content-heading">
                      {data.headingName}
                    </div>
                    <div className="case-studies-content">
                      {data.description}
                    </div>
                    <button
                      className="case-studies-read-more-wrapper"
                      onClick={() => {
                        moreCaseStudyClickFunc(data.name);
                      }}
                    >
                      Read More{" "}
                      <img
                        src="../../images/caseStudies/arrow.svg"
                        alt="arrow"
                      ></img>
                    </button>
                  </div>
                </CardContent>
              </Card>
            )
          ) : (
            <Card key={data.id} className="case-studies-card">
              <CardMedia component="img" image={data.image} alt="financial" />
              <CardContent className="case-studies-card-content-wrapper">
                <div className="case-studies-content-wrapper">
                  <div className="case-studies-content-heading">
                    {data.headingName}
                  </div>
                  <div className="case-studies-content">{data.description}</div>
                  <button
                    className="case-studies-read-more-wrapper"
                    onClick={() => {
                      moreCaseStudyClickFunc(data.name);
                    }}
                  >
                    Read More{" "}
                    <img
                      src="../../images/caseStudies/arrow.svg"
                      alt="arrow"
                    ></img>
                  </button>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* mobileResponsive */}
      <div className="mobile-cast-studies-card-wrapper case-studies-card-wrapper">
        <Slider {...settings}>
          {caseStudies?.caseStudies?.map((data) =>
            titleName ? (
              data.name != selectedId && (
                <Card key={data.id} className="case-studies-card">
                  <CardMedia
                    component="img"
                    image={data.image}
                    alt="financial"
                  />
                  <CardContent className="case-studies-card-content-wrapper">
                    <div className="case-studies-content-wrapper">
                      <div className="case-studies-content-heading">
                        {data.headingName}
                      </div>
                      <div className="case-studies-content">
                        {data.description}
                      </div>
                      <button
                        className="case-studies-read-more-wrapper"
                        onClick={() => {
                          moreCaseStudyClickFunc(data.name);
                        }}
                      >
                        Read More{" "}
                        <img
                          src="../../images/caseStudies/arrow.svg"
                          alt="arrow"
                        ></img>
                      </button>
                    </div>
                  </CardContent>
                </Card>
              )
            ) : (
              <Card key={data.id} className="case-studies-card">
                <CardMedia component="img" image={data.image} alt="financial" />
                <CardContent className="case-studies-card-content-wrapper">
                  <div className="case-studies-content-wrapper">
                    <div className="case-studies-content-heading">
                      {data.headingName}
                    </div>
                    <div className="case-studies-content">
                      {data.description}
                    </div>
                    <button
                      className="case-studies-read-more-wrapper"
                      onClick={() => {
                        moreCaseStudyClickFunc(data.name);
                      }}
                    >
                      Read More{" "}
                      <img
                        src="../../images/caseStudies/arrow.svg"
                        alt="arrow"
                      ></img>
                    </button>
                  </div>
                </CardContent>
              </Card>
            )
          )}
        </Slider>
      </div>
    </div>
  );
};

export default CaseStudiesComponent;
